import {useTranslation} from "react-i18next";
import React, {useContext, useEffect, useState} from "react";
import {Store} from "../../../Store";
import Button from "../../UI/Button/Button";
import TransitionsModal from "../../UI/Modal/Modal";
import style from "../Supplier/supplier.module.css";
import Grid from "@material-ui/core/Grid";
import Table from "../Table";
import axios from "../../../API/api";
import time from "../../../assets/tables/time.svg";
import TableModal from "../Supplier/TableModal";
import close from "../../../assets/tables/close.svg";
import timeDark from "../../../assets/tables/timeDark.svg";
import Input from "../../UI/Input/TextField";

export default function DetailsSupplier(props) {
    const {t} = useTranslation();
    const {state, dispatch} = useContext(Store);
    const [open, setOpen] = useState(false);
    const [mainData, setMainData] = useState([]);
    const [inputs, setInputs] = useState( props.detailsInfo );


    useEffect(() => {
        if (open === true) {
            Promise.all([
                axios.get(`/api/v1/supplier/update/dto?selfId=${props.detailsInfo.id}`, {headers: {Authorization: `Bearer ${state.token}`}}),
                // axios.get(`/api/v1/supplier/${props.detailsInfo.id}`, {headers: {Authorization: `Bearer ${state.token}`}})
            ]).then(function (res) {
                const suppliers = res[0];
                setMainData(suppliers.data.data.supplierProducts)
            }).catch((err) => {
                console.log(err)
                if (err.response ? err.response.status === 401 : '') {
                    localStorage.removeItem('id_token');
                    return dispatch({type: 'SET_TOKEN', payload: ''})
                }
            })
        }
    }, [open, dispatch, props.detailsInfo.id, state.token]);


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: '№',
                accessor: 'id',
                Width: 10,
                Cell: ({row}) => {
                    return state.page*state.perPage +row.index+1
                }
            },
            {
                Header: t('Name'),
                accessor: 'productName',
            },
            {
                Header: t('Category'),
                accessor: 'categoryName',
            },
            {
                Header: t('History price'),
                Cell: (row) => {
                    return <div className={style.action}>
                        <TableModal img={state.mode === 'dark' ? time : timeDark} title={t('historyActions')} detailsItemInfo={row.row.original} />
                    </div>
                }
            },
        ],
        [t, state.mode, state.page, state.perPage]
    );

    const data = React.useMemo(
        () => mainData,
        [mainData]
    );

    const form = [
        {
            label: t('orgName'),
            variant: 'outlined',
            name: 'organizationName',
            value: 'organizationName',
            textArea: true,
            nested: false,
            disabled: true
        },
        {
            label: t('position'),
            variant: 'outlined',
            name: 'supplierPosition',
            value: 'supplierPosition',
            textArea: true,
            nested: false,
            disabled: true
        },
        {
            label: t('TIN (supplier)'),
            variant: 'outlined',
            name: 'supplierInn',
            value: 'supplierInn',
            textArea: true,
            nested: false,
            disabled: true
        },
        {
            label: t('NameSurMidName'),
            variant: 'outlined',
            name: 'supplierName',
            value: 'supplierName',
            textArea: true,
            nested: false,
            disabled: true
        },
        {
            label: t('emailAdd'),
            variant: 'outlined',
            name: 'email',
            value: 'email',
            textArea: true,
            nested: false,
            disabled: true
        },
        {
            label: t('telNum'),
            variant: 'outlined',
            name: 'phoneNumber',
            value: 'phoneNumber',
            textArea: true,
            nested: false,
            disabled: true
        },
    ];

    return (
        <div>
            {props.img ? <img src={props.img} alt="" onClick={handleOpen}/> :
                <Button btnType="addUser" clicked={handleOpen}>{t('add')}</Button>}
            <TransitionsModal open={open} handleClose={handleClose}>
                <div className={[state.mode === 'light' ? style.modalLight : style.modalDark, "drag-modal"].join(' ')} style={{width: '80%', marginLeft: '10%'}}>
                    {/*<img src={logo} alt="" className={style.backLogo}/>*/}
                    <h3>{t('Add supplier')}</h3>
                    <img src={close} alt="" className={[style.close, 'close'].join(' ')} onClick={handleClose}/>
                    <Grid className={style.form} container spacing={3}>
                        {form.map((element, i) =>
                            <Grid item xs={12} md={3} xl={3}>
                                <Input
                                    inputType={'textField'}
                                    variant="outlined"
                                    size="small"
                                    name={element.name}
                                    type={element.name}
                                    nested={element.nested}
                                    value={inputs[element.value] || null}
                                    label={element.label}
                                    disabled={element.disabled}
                                />
                            </Grid>
                        )}
                    </Grid>
                    <hr className={style.hr}/>
                    <p>{t('Item product')}</p>
                    <Table data={data} columns={columns}/>
                </div>
            </TransitionsModal>
        </div>
    )


}